"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _axios = _interopRequireDefault(require("axios"));
var _basic = _interopRequireDefault(require("./_basic"));
var _bluebird = _interopRequireDefault(require("bluebird"));
class SharedApi extends _basic.default {
  /**
   * @constructor
   */
  constructor(_ref) {
    let {
      userTokenFactory,
      sdkApiUrl
    } = _ref;
    super({
      userTokenFactory
    });
    this.sdkApiUrl = sdkApiUrl;
    this.usersUrl = `${sdkApiUrl}/users`;
    this.sharingUrl = `${sdkApiUrl}/shared`;
    this.publicSharingUrl = `${sdkApiUrl}/public/shared`;
  }
  async getGuests(limit, last) {
    const headers = await this.getHeaders();
    const config = _lodash.default.merge({
      params: {}
    }, headers);
    if (limit) {
      config.params.limit = limit;
    }
    if (last) {
      config.params.last = last;
    }
    return _bluebird.default.try(() => _axios.default.get(`${this.usersUrl}/shared`, config).then(response => _bluebird.default.resolve(response.data)));
  }
  async deleteShared(userId, entityType, entityId) {
    const headers = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.delete(`${this.sharingUrl}/${userId}/${entityType}/${entityId}`, headers).then(response => _bluebird.default.resolve(response.data)));
  }
  async addShared(userId, entityType, entityId) {
    const headers = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.post(`${this.sharingUrl}/${userId}/${entityType}/${entityId}`, null, headers).then(response => _bluebird.default.resolve(response.data)));
  }
  async addSharedMany(userId, entityType, entityIds) {
    const headers = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.post(`${this.sharingUrl}/${userId}/${entityType}`, {
      ids: entityIds
    }, headers).then(response => _bluebird.default.resolve(response.data)));
  }

  //public sharing
  async deletePublicShared(entityType, entityId) {
    const headers = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.delete(`${this.publicSharingUrl}/${entityType}/${entityId}`, headers).then(response => _bluebird.default.resolve(response.data)));
  }
  async addPublicShared(entityType, entityId) {
    const headers = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.post(`${this.publicSharingUrl}/${entityType}/${entityId}`, null, headers).then(response => _bluebird.default.resolve(response.data)));
  }
  async getPublicShared(entityType, entityId) {
    const headers = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.get(`${this.publicSharingUrl}/${entityType}/${entityId}`, headers).then(response => _bluebird.default.resolve(response.data)));
  }
}
var _default = SharedApi;
exports.default = _default;